module.exports = __webpack_public_path__ + "static/deal_1-23ec805a3691e5496f6249624164b46f.png";